import { useState } from "react";
import { toast } from "sonner";
import { Globe } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { trackEvent } from "@/lib/analytics";

const LOCALES = [
    { key: "en", label: "EN" },
    { key: "hi", label: "हि" },
];

export default function LanguagePicker() {
    const { user, refresh } = useAuth();
    const [busy, setBusy] = useState(false);
    const active = user?.locale || "en";

    const change = async (loc) => {
        if (loc === active || busy) return;
        setBusy(true);
        try {
            await api.post("/onboarding", {
                preferred_name: user?.preferred_name || user?.name || "friend",
                intent: user?.intent || null,
                locale: loc,
            });
            trackEvent("locale_changed", { locale: loc });
            await refresh?.();
            toast.success("Pax will speak that from the next message.");
        } catch (e) {
            toast.error(e?.response?.data?.detail || "couldn't switch");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="inline-flex items-center gap-1 bg-clay/60 border border-clayHover rounded-full p-0.5" data-testid="locale-picker">
            <Globe className="w-3.5 h-3.5 text-inkSoft ml-2" />
            {LOCALES.map((l) => (
                <button
                    key={l.key}
                    onClick={() => change(l.key)}
                    data-testid={`locale-${l.key}`}
                    disabled={busy}
                    className={`px-2.5 py-1 rounded-full text-xs font-body transition-colors ${
                        l.key === active ? "bg-white text-ink shadow-soft" : "text-inkSoft hover:text-ink"
                    }`}
                >
                    {l.label}
                </button>
            ))}
        </div>
    );
}
